import React, { Component } from 'react';
import Swiper from 'react-id-swiper';


import './transitions.css';

import 'swiper/dist/css/swiper.css';

import './BasedocPopup.css';

const _SWIPER_PARAMS = {
    /*
    effect: 'slide',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    */
    direction: 'horizontal',
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },    
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30
  }

class BasedocPopup extends Component {


    constructor(props) {

        super(props);

        this.state = {
        }
          
    }


    render() {
       
        const { onExitBasedocPopup , popupContent} = this.props;

        const textePopup = popupContent.textePopup;
        const titrePopup = popupContent.titrePopup;
        const mediasPopup = popupContent.mediasPopup;
        const creditsPopup = popupContent.creditsPopup;

        let contenuPopup = null;

        switch(popupContent.typePopup)
        {

            case 'image':
            {

                let images = [];
                if(mediasPopup.length > 0)
                {
                    //if( mediasPopup.indexOf('.jpg') >= 0) 
                    //{
                        /* voir Vitrail exemple complet d'utilisation */
                        images = mediasPopup.map( i => {
                            const style = { backgroundImage: `url(medias/${i})` };
                            return <div key={i} style={style}></div>
                        });
                    //}
                }else   /* pas de medias, valeur par défaut: */
                {
                    const style = { backgroundImage: 'url(medias/Vide.jpg)' };
                    images.push( <div key="slide0" style={style}></div> );
                }

                let credits = false;

                if(creditsPopup)
                {
                    credits = <div className='creditsPopup'> 
                        {creditsPopup.map((item, key) => {
                            return <span key={key}>{item}<br/></span>   /* pour ajouter des <br/> */
                        })}
                        </div>
                }

                contenuPopup = 
                    <div className='BasedocPopup' key='popup' >                        
                        <div className='zoneImages'>
                        <Swiper {..._SWIPER_PARAMS} ref={node => { if (node) this.swiper = node.swiper } }>
                            {images}
                        </Swiper>
                        </div>
                        <div className='zoneTextes'>
                            <div className='titrePopup'> 
                            {titrePopup.map((item, key) => {
                                return <span key={key}>{item}<br/></span>   /* pour ajouter des <br/> */
                            })}
                            </div>
                            <div className='textePopup'> 
                            {textePopup.map((item, key) => {
                                return <span key={key}>{item}<br/></span>   /* pour ajouter des <br/> */
                            })}
                            </div>
                            { credits }
                        </div>                
                        <div className='icon_close' onClick={ onExitBasedocPopup }></div>
                    </div>
                   
            };break;
            case 'video':
            {
                const fichier_video = 'medias/'+mediasPopup[0];

                contenuPopup = <div className='BasedocPopup' key='popup' >
                                    <video className='video_player' src={ fichier_video } controls controlsList="nofullscreen nodownload noremoteplayback" webkit-playsinline playsInline autoPlay/>
                                    <div className='icon_close' onClick={ onExitBasedocPopup }></div>
                                </div>
            };break;
            case 'audio':
            {
                const fichier_audio = 'medias/'+mediasPopup[0];
                const image = 'medias/'+mediasPopup[1];

                let zoneMedia = null;
                if(image){
                    let style = { backgroundImage: 'url(./'+image };  
                    zoneMedia = <div className='portraitAudio' style={ style }></div>;
                }
                else        zoneMedia = <div className='iconPlayerAudio'></div>;

                contenuPopup = <div className='BasedocPopup' key='popup' >
                                    { zoneMedia }
                                    <audio className='audio_player' src={ fichier_audio } controls controlsList="nofullscreen nodownload noremoteplayback" webkit-playsinline playsInline autoPlay/>
                                    <div className='icon_close' onClick={ onExitBasedocPopup }></div>
                                </div>;
            };break;
            default:
            {
                this.props.logFn("BasedocPopup:render() !!!ERROR type de popup indéfini, ne devrait pas arriver");
            };
        };

        return( 
            <div key='popolopopopup'>
                <div className='bkg_black' ></div>
                { contenuPopup} 
            </div>);
  }


}

//----------------------------------------------------------------------------

export default BasedocPopup;



// WEBPACK FOOTER //
// ./src/BasedocPopup.js